import React from 'react';
import Modal from '../../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import QuestionnaireResults from './QuestionnaireResults';
// @ts-ignore
interface Props {
	isOpen: boolean;
	onClose: () => void;
	patientId: string;
	questionnaireCode: string;
	questionnaireName: string;
	roundValuesTo?: number;
}

const QuestionnaireResultsModal: React.FC<Props> = ({
	isOpen,
	onClose,
	patientId,
	questionnaireCode,
	questionnaireName,
	roundValuesTo,
}) => {
	const { isCase } = useTreatmentContext();

	return (
		<Modal
			opened={isOpen}
			onClose={onClose}
			wrapChat={isCase}
			fullScreen={true}>
			<Modal.Header title={'base.questionnaireResult.one'} />
			<Modal.Content>
				<QuestionnaireResults
					patientId={patientId}
					questionnaireCode={questionnaireCode}
					questionnaireName={questionnaireName}
					roundValuesTo={roundValuesTo}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default QuestionnaireResultsModal;
